import styled from 'styled-components';
export const MenuCellWrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;
